import { render, staticRenderFns } from "./ReferralPromotionPickerFormItem.vue?vue&type=template&id=6b86a04b&"
import script from "./ReferralPromotionPickerFormItem.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionPickerFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b86a04b')) {
      api.createRecord('6b86a04b', component.options)
    } else {
      api.reload('6b86a04b', component.options)
    }
    module.hot.accept("./ReferralPromotionPickerFormItem.vue?vue&type=template&id=6b86a04b&", function () {
      api.rerender('6b86a04b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReferralPromotionPickerFormItem.vue"
export default component.exports